import { render, staticRenderFns } from "./RegisterEmployee.vue?vue&type=template&id=0a897daa&"
import script from "./RegisterEmployee.vue?vue&type=script&lang=js&"
export * from "./RegisterEmployee.vue?vue&type=script&lang=js&"
import style0 from "./RegisterEmployee.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports